import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  downloadFile,
  headTitleList,
  headTitleList2,
  navigatePath,
} from "./parts";
import { Box, Link } from "@mui/material";
import TkTable from "../../components/atoms/TkTable";
import { GlobalContext } from "../../context/globalContext";
import TkMemo from "../../components/molecules/TkMemo";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import { BusinessContext } from "../../context/businessContext";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import { httpAPI_APP015, httpAPI_APP016 } from "./api/request";
import { IAPI_APP015_Response, IAPI_APP016_Request } from "../../type/apiType";
import { httpAPI_COM005, httpAPI_COM009 } from "../SCRC070104/api/request";
import {
  applyEvent,
  CommonOrCommonRetirementFlug,
  FormKbn,
  Status,
} from "../../assets/data/Constants";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkBackButton from "../../components/molecules/TkBackButton";
import "./_style.scss";
import { TkGetCode } from "../../utils/TkGetCode";
import { isStatusAfterApproval } from "../../utils/useTools";

/**
 * SCRW110006 稟議・決裁対象一覧
 * @return SCRW110006 稟議・決裁対象一覧
 */
const SCRW110006 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [bodyList, setBodyList] = useState<any>([]);
  const [status, setStatus] = useState<any>();

  const [businessType, setBusinessType] = useState<any>();
  const [isOpen, setIsOpen] = useState(false);
  const [memoBodyList, setMemoBodyList] = useState([]);
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [response, setResponse] = useState<IAPI_APP015_Response>({});
  const [showTable, setShowTable] = useState(false);
  const [readyFile, setReadyFile] = useState<any[]>([]);
  const [bodyList2, setBodyList2] = useState([]);

  const applyId = businessState.groupApply?.applyId ?? location.state?.applyId;
  const jobType =
    businessState.groupApply?.businessType ??
    businessState.common?.businessType;
  const isScheduledPaymentDateVisible =
    jobType === "JOB-72" || jobType === "JOB-88" || jobType === "JOB-89";
  const timerId = useRef<NodeJS.Timeout | null>(null);

  const makeDownLoadFileReq = (res: IAPI_APP015_Response) => {
    let fileList = downloadFile.filter((file) => {
      const canShowStatus = ["08", "11", "13"];
      let finalBusiness = false;
      let finalStatus = true;

      if (file.businessType === jobType) {
        finalBusiness = true;
      }

      if (file.status) {
        finalStatus = canShowStatus.includes(res.groupLatestApplyStatus ?? "");
      }

      if (file.applyType) {
        finalStatus = res.applyList?.some(
          (item: any) => item.businessType === "JOB-77"
        )!;
      }

      return finalBusiness && finalStatus;
    });
    // 対象となる帳票種別のレコードが存在すること
    fileList = fileList?.filter?.(
      (f) => !!res?.formList?.find?.((_f) => _f.formClass === f.formClass)
    );
    setReadyFile(fileList);
    return fileList;
  };

  // 初期化
  const handleInit = async () => {
    try {
      const res = await httpAPI_APP015({
        applyId,
      });

      if (res.resultCd === "I0000") {
        setBodyList(funInfoBodyList(res));
        setStatus(res.groupLatestApplyStatus);

        setBusinessType(res.applyList?.[0].businessType);
        setResponse(res);

        const dataMemo: any = [];
        if (res.statusList && res.statusList.length >= 1) {
          setShowTable(true);
        }
        res.statusList?.forEach((item: any) => {
          const data = [
            {
              children: item.managerName,
            },
            {
              children: item.process,
            },
            {
              children: item.createDate,
              align: "center",
            },
            {
              children: item.processComment,
            },
          ];
          dataMemo.push(data);
        });

        if (businessState?.groupApply?.businessType) {
          setBusinessState({
            ...businessState,
            common: {
              ...businessState.common,
              businessType: jobType,
            },
          });
        } else {
          setBusinessState({
            ...businessState,
            groupApply: {
              ...businessState.groupApply,
              businessType: jobType,
            },
          });
        }

        setMemoBodyList(dataMemo);
        setState({
          ...state,
          errorMsgId: "",
        });

        const formList = makeDownLoadFileReq(res);
        if (formList && formList.length > 0) {
          handleDownloadData(
            formList?.map((item: any) => ({
              formClass: item.formClass,
              formKbn: FormKbn["申請"],
            }))
          );
        }
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleMove = (item: any) => {
    setBusinessState({
      ...businessState,
      common: {
        ...businessState.common,
        contractorNo: item.contractorNo,
        contractorName: item.actionRequiredTitle,
        businessType: item.businessType,
      },
      groupApply: { applyId, businessType: jobType },
    });

    navigate(navigatePath[item.businessType], {
      state: { applyId: item.applyId },
    });
  };

  function funInfoBodyList(res: any): any[] {
    const bodyList = res.applyList.map((item: any) => {
      return [
        {
          children: `${item.contractorNo ? item.contractorNo + ":" : ""}${
            item.actionRequiredTitle ? item.actionRequiredTitle : ""
          }`,
        },
        {
          children: (
            <Link onClick={() => handleMove(item)} className="link">
              {item.businessTypeName}
            </Link>
          ),
        },
        {
          children: item.applyDate,
        },
        {
          children: TkGetCode(Status, item.latestApplyStatus),
        },
        {
          children: item.managerUserId,
        },
      ];
    });
    return bodyList;
  }

  useEffect(() => {
    setReadyFile([]);
    handleInit();
    return () => {
      if (timerId.current) {
        clearTimeout(timerId.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const res = response;

    const isBodylist4Visible = isStatusAfterApproval(
      res.groupLatestApplyStatus
    );

    const bodyList2: any = [
      [
        {
          children: (
            <>
              {readyFile.map((file) => (
                <Box key={file.formClass}>
                  <TkDownloadLink
                    base64filedata={file.fileBase64}
                    dataname={file.fileName}
                    linkName={file.fileName}
                    linkDisabled={!file.fileBase64}
                    downloadBase64={true}
                  />
                </Box>
              ))}
            </>
          ),
        },
        {
          children: isBodylist4Visible ? res.symbolNo : undefined,
          verticalAlign: "top",
        },
        {
          children: isBodylist4Visible ? res.decisionDate : undefined,
          verticalAlign: "top",
        },
      ],
    ];

    setBodyList2(bodyList2);
  }, [readyFile, response]);

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    }
    if (event.target.type === "checkbox") {
      setMemoCheck(event.target.value);
    }
  };

  const setOpen = () => {
    setIsOpen(false);
  };

  const handleDownloadData = async (FormList: any) => {
    try {
      // 帳票作成状況取得APIを呼び出す。
      const res = await httpAPI_COM009({
        applyId,
        FormList,
      });

      let nextReq = FormList;
      res.FormList?.forEach((form) => {
        if (form.formOutputStatus === "3") {
          handleFileDownload(form.requestId);
          nextReq = nextReq.filter((i: any) => i.formClass !== form.formClass);
        }
      });

      if (res.resultCd === "I0000") {
        if (!res.FormList?.every((item) => item.formOutputStatus === "3")) {
          timerId.current = setTimeout(() => {
            handleDownloadData(nextReq);
          }, 10000);
        }
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleFileDownload = async (requestId: any) => {
    // 帳票ダウンロード(汎用)APIを呼び出す
    try {
      const res = await httpAPI_COM005({
        formList: [{ requestId: requestId }],
      });

      if (res.resultCd === "I0000") {
        if (!res.formList?.length) return;

        setReadyFile((prev: any) => {
          return prev.map((i: any) => {
            const target = res.formList?.find(
              (item) => item.formClass === i.formClass
            );
            if (target) {
              return { ...i, fileBase64: target.fileBase64 };
            }
            return i;
          });
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const makeHttpObj = (
    applyEvent: string,
    formData?: any
  ): IAPI_APP016_Request => {
    const req: IAPI_APP016_Request = {
      applyId: applyId,
      applyEvent,
      contractorNo: response.applyList?.[0].contractorNo,
      inquiryCode: memoCheck ? "2" : undefined,
      screenId: "SCRW110006",
      reason: memoData,
    };
    if (formData) {
      req.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";
      req.transferDueDateForGroupApply = formData.scheduledPaymentDate;
      req.decisionDate = formData.settlementDate;
    }

    return req;
  };

  const btnEvent = async (btnName: keyof typeof applyEvent) => {
    const event = applyEvent[btnName];
    switch (event) {
      case applyEvent["担当者に差戻し"]:
      case applyEvent["課長代理確認"]:
      case applyEvent["上長承認"]:
      case applyEvent["通知"]:
      case applyEvent["郵送"]:
        handleUpdate(event);
        break;

      case applyEvent["承認"]:
        setIsOpen(true);
        break;

      default:
        return;
    }
  };

  const handleUpdate = async (event: any, formData?: any) => {
    try {
      const res = await httpAPI_APP016({
        ...makeHttpObj(event, formData),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRW110006" data-testid="SCRW110006PageForTest">
      {status && (
        <TkKikoStepper
          applicationFlowType="TYPE2" //申請フロー種別
          businessType={businessType} //業務タイプ
          applicationStatus={status} //申請ステータス
          corporateApplicationClassification="1" //法人申請区分
        />
      )}

      <TkTable headList={headTitleList} bodyList={bodyList} pagin={true} />

      <TkMemo
        data-testid="SCRW110006Meomo"
        bodyList={memoBodyList}
        onChange={onChange}
        showTable={showTable}
        disabledCheckBox={true}
      />

      <TkTableWithNoLine headList={headTitleList2} bodyList={bodyList2} />
      <Box className="buttonGroup">
        <TkBackButton className="tkBottonMr" />
        <TkViewButtonJudgement
          flowType="TYPE2"
          Status={status}
          onClick={btnEvent}
          data-testid="TkViewButtonJudgement"
        />
      </Box>

      <TkApprovalDateSymbolNumberRegistrationDialog
        open={isOpen}
        onSuccess={(data: any) => handleUpdate(applyEvent["承認"], data)}
        onClose={setOpen}
        isScheduledPaymentDateVisible={isScheduledPaymentDateVisible}
        isScheduledPaymentDateDisabled
        wantToSetValue={{
          scheduledPaymentDate: response.transferDueDate,
        }}
      />
    </Box>
  );
};

export default SCRW110006;
